import { SectionTitle } from "./SectionTitle";

const features = [
  {
    icon: "ri-timer-flash-line",
    title: "每日准时更新",
    desc: "番木瓜漫画最新上架每日更新，新作上架不拖延，追更零等待。",
  },
  {
    icon: "ri-calendar-check-line",
    title: "当季导视精准",
    desc: "新番导视覆盖本季新作，帮你快速锁定值得追的作品，告别盲目开坑。",
  },
  {
    icon: "ri-team-line",
    title: "读者口碑之选",
    desc: "热门新番与连载新开均由真实追更用户打榜推荐，追更不踩雷。",
  },
  {
    icon: "ri-flag-line",
    title: "连载动态追踪",
    desc: "连载新开一站掌握，更新节点与进度随时同步，追更计划更从容。",
  },
];

export default function WhyUs() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionTitle
          eyebrow="WHY US"
          title="为什么选择番木瓜漫画"
          desc="从新番导视到每日上架，从热门榜到连载新开，我们专注做好追更这件事。"
        />

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {features.map((f) => (
            <div
              key={f.title}
              className="rounded-2xl border border-background-200 bg-background-100/60 p-6 transition hover:border-primary-300"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary-500 text-background-50">
                <i className={`${f.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 text-base font-bold text-foreground-900">
                {f.title}
              </h3>
              <p className="mt-2 text-sm leading-6 text-foreground-600">
                {f.desc}
              </p>
            </div>
          ))}
        </div>

        {/* 口碑 */}
        <div className="mt-6 grid grid-cols-2 gap-4 rounded-2xl border border-background-200 bg-primary-100/40 p-6 sm:grid-cols-4 md:p-8">
          {[
            { v: "98%", l: "读者满意度" },
            { v: "5000+", l: "每日追更读者" },
            { v: "200+", l: "收录新番作品" },
            { v: "4.9", l: "读者综合评分" },
          ].map((s) => (
            <div key={s.l} className="text-center">
              <p className="font-heading text-2xl text-primary-700 md:text-3xl">
                {s.v}
              </p>
              <p className="mt-1 text-sm text-foreground-600">{s.l}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}